import { useApp } from "../context/AppContext";
import { IMAGES } from "../lib/site";
import { Reveal, SectionHead } from "./Reveal";

export const Gallery = () => {
  const { t } = useApp();
  const items = [
    { src: IMAGES.interior, alt: "Interior kabin Big Bus NTA", cls: "md:col-span-7", h: "h-72 md:h-[420px]" },
    { src: IMAGES.office, alt: "Kantor PT. Natama Trans Asia", cls: "md:col-span-5 md:mt-20", h: "h-72 md:h-[380px]" },
    { src: IMAGES.mediumInterior, alt: "Interior kabin Medium Bus NTA", cls: "md:col-span-4", h: "h-72 md:h-[360px]" },
    { src: IMAGES.cockpit, alt: "Area kemudi Medium Bus NTA", cls: "md:col-span-4", h: "h-72 md:h-[360px]" },
    { src: IMAGES.hiaceInterior, alt: "Interior kabin Toyota Hiace NTA", cls: "md:col-span-4", h: "h-72 md:h-[360px]" },
    { src: IMAGES.interiorFront, alt: "Interior kabin Big Bus tampak depan", cls: "md:col-span-7", h: "h-72 md:h-[420px]" },
    { src: IMAGES.scenery, alt: "Destinasi wisata religi", cls: "md:col-span-5", h: "h-72 md:h-[380px]" },
  ];
  return (
    <section id="galeri" className="border-y border-border bg-secondary/40 py-24 dark:bg-secondary/20 md:py-36" data-testid="gallery-section">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <SectionHead overline={t.gallery.overline} title={t.gallery.title} sub={t.gallery.sub} testId="gallery-head" />
        <div className="mt-16 grid grid-cols-1 gap-6 md:mt-20 md:grid-cols-12">
          {items.map((img, i) => (
            <Reveal key={i} delay={i * 0.06} className={img.cls}>
              <div className={`group overflow-hidden rounded-2xl ${img.h}`} data-testid={`gallery-img-${i}`}>
                <img
                  src={img.src}
                  alt={img.alt}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
